import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteByIdAkOdePosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionAkOde/deleteByIdAkOdePosInsatallment',
      requesterInfo,
    })
  }

  public async deleteByIdAkOdePosInsatallment(request: number): Promise<CommonPostResponse> {
    this.props.url = `${this.props.url}?Id=${request}`
    return await this.postAsync<CommonPostResponse>()
  }
}

